module.exports = __webpack_public_path__ + "img/91.a16a3a7d.jpg";